import { FaroCoreApiTypes } from "@stellar/core-api-client";

const STATUS_ORDER: Record<FaroCoreApiTypes.PlanStatusIdentifier, number> = {
  active: 0,
  invalid: 1,
  inactive: 2,
  deactivated: 3,
};

/** Custom sorting for plan status */
export function sortByPlanStatus<
  T extends FaroCoreApiTypes.PlanStatusIdentifier,
>(a: T, b: T): number {
  return STATUS_ORDER[a] - STATUS_ORDER[b];
}
